import { memo } from 'react';

import Draft from './Draft.tsx';

export const DraftContainer = () => {
  return <Draft />;
};

export default memo(DraftContainer);
